import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { authActions } from "../store";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  FormInput
} from "shards-react";
import "./loaderStyles.css"; // Import spinner styling

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state
  const dispatch = useDispatch();
  const history = useHistory();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true); // Show loader

    try {
      const response = await fetch("https://vaptlabreport.com/shieldapi/login.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email_id: email, password })
      });

      const result = await response.json();

      if (result.status === "success") {
        const { user, token } = result;
        const packagesArray = user.packages ? user.packages.split(",") : [];

        // Store user data in localStorage for persistence
        localStorage.setItem("company_id", user.company_id);
        localStorage.setItem("company_name", user.company_name);
        localStorage.setItem("packages", JSON.stringify(packagesArray));
        localStorage.setItem("user_id", user.user_id);
        localStorage.setItem("email_id", user.email_id);
        localStorage.setItem("token", token);
        localStorage.setItem("isLoggedIn", "true");
        if( user.LicenceKey){
        localStorage.setItem("LicenceKey", user.LicenceKey);
        }
        

        dispatch(authActions.login());
        history.push("/analytics");
      } else {
        setError("Invalid email or password. Please try again.");
      }
    } catch (error) {
      setError("An error occurred. Please try again later.");
    } finally {
      setLoading(false); // Hide loader after response
    }
  };

  return (
    <Container fluid className="main-content-container d-flex align-items-center justify-content-center vh-100">
      <Row className="w-100 justify-content-center" style={{ marginTop: "-20vh" }}>
        <Col lg="4" md="6" className="auth-form mx-auto">
          <Card className="shadow-lg">
            <CardBody>
              <img
                className="auth-form__logo d-table mx-auto mb-3"
                src={require("../images/logo.png")}
                alt="VAPTlabs"
              />

              <h5 className="auth-form__title text-center mb-4">
                Login to Your Account
              </h5>

              {error && <p className="text-danger text-center">{error}</p>}

              <Form onSubmit={handleLogin}>
                <FormGroup>
                  <label htmlFor="email">Email address</label>
                  <FormInput
                    type="email"
                    id="email"
                    placeholder="Enter email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <label htmlFor="password">Password</label>
                  <FormInput
                    type="password"
                    id="password"
                    placeholder="Password"
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </FormGroup>

                {loading ? (
                  <div className="spinner d-table mx-auto" /> // Show loader in place of button
                ) : (
                  <button
                    className="btn btn-accent d-table mx-auto"
                    type="submit"
                  >
                    Login
                  </button>
                )}
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
